<template lang="pug">
section
  header.header-settings
    .tabs
      .tab.primary-text.active
        span Team

  section.sub-section
    h4 Invite team members to help manage your account.
    form(@submit.prevent="submit")
      AlertBox(v-if="error", type="danger", :text="error")

      .form-field(
        :class="{ error: $v.form.email.$error, 'error-required': !$v.form.email.required }"
      )
        label
          h6 Email Address
          input(
            v-model="$v.form.email.$model",
            type="email",
            placeholder="john@example.com"
          )
      .form-field.no-margin
        SubmitButton(label="Invite", :formState="formState")

  //-h3 Team
  table
    tr
      th
      th Name
      th Email Address
    tr(v-for="user in users")
      td
        UserAvatar(:user="user", size="small")
      td {{ user.fullName }}
      td {{ user.email }}
    tr.pending(v-for="user in pendingInvites")
      td
        span(@click="confirmDelete(user)")
          a
            font-awesome-icon(:icon="['fas', 'times']", fixed-width)
      td.name pending
      td {{ user.email }}
</template>

<script>

import { required, email } from 'vuelidate/lib/validators'
import { form } from '@/mixins/form'
import { mapState } from 'vuex'

export default {
  name: 'SettingsTeam',
  mixins: [form],
  beforeMount () {
    this.$store.dispatch('getPendingInvites')
  },
  data () {
    return {
      formState: 'initial',
      form: {
        email: ''
      },
      error: null
    }
  },
  validations: {
    form: {
      email: {
        required,
        email
      }
    }
  },
  computed: {
    ...mapState({
      users: state => state.users,
      pendingInvites: state => state.pendingInvites
    })
  },
  methods: {
    confirmDelete (invite) {
      this.$DialogBox.open({
        parent: this,
        open: true,
        header: 'Delete Invite?',
        message: 'Just double checking!',
        onConfirm: () => {
          this.deleteInvite(invite)
        }
      })

    },
    deleteInvite (invite) {
      this.$store.dispatch('deleteInvite', invite.token)
    },
    submit () {
      let invite = Object.assign({}, this.form)

      if (this.__formInvalid()) return

      this.formState = 'pending'

      this.$store.dispatch('postInvites', this.form).then(() => {
        //this.pending = [...this.pending, invite]
        this.formState = 'success'
        this.form = {
          email: ''
        }
        this.$v.$reset()
      }, error => {
        console.log(error)
        this.error = error
        this.formState = 'initial'
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.pending
  color $text-light
  a
    cursor pointer
  .name
    font-style italic
</style>
